import React from 'react'
import { graphql } from "gatsby";
import { Helmet } from 'react-helmet';

import Home from '../content/parts/home.jsx'
import { Layout } from '@components/Layout.jsx'

const Index = ({ data }) => {
    const justIn = data?.justInCollection;
    const bestSellerCollection = data?.bestSellerCollection;
    //const homeCollection = data?.homeCollection;
    const featuredCollections = data?.featuredCollections?.edges;

	return (
        <Layout gaEvent={{
			eventName: 'page_view', 
			params: {
				page_path: '/',
				page_title: 'Blackbough Swim: Designed for the Tropical Soul | Bikinis and Swimwear - Blackbough Swim PH',
				queryName: 'home page',
			},
		}}>
            <Helmet>
                <title>Blackbough Swim: Designed for the Tropical Soul | Bikinis and Swimwear - Blackbough Swim PH</title>
                <meta name="description" content="Find your new favorite bikini. Shop triple-lined, sustainably-made swimwear in the cutest prints and flattering styles for your every sun-soaked adventure." />
            </Helmet>

            <Home justIn={justIn} bestSellerCollection={bestSellerCollection} /*homeCollection={homeCollection}*/ featuredCollections={featuredCollections} />
        </Layout>
		
	)
}


export const query = graphql`
  query {
    justInCollection: shopifyCollection(handle: { eq: "just-in" }) {
      products {
        id
        title
        handle
        featuredImage {
          src
        }
        media {
          preview {
            image {
              src
              gatsbyImageData
            }
          }
        }
        priceRangeV2 {
          minVariantPrice {
            amount
          }
        }
        tags
        metafields {
            id
            key
            value
        }
        seo {
            title
            description
        }
        variants {
            id
            storefrontId
            title
            position
            availableForSale
            inventoryQuantity
            compareAtPrice
        }
      }
    }
    bestSellerCollection: shopifyCollection(handle: { eq: "best-sellers" }) {
      products {
        id
        title
        handle
        featuredImage {
          src
        }
        media {
          preview {
            image {
              src
              gatsbyImageData
            }
          }
        }
        priceRangeV2 {
          minVariantPrice {
            amount
          }
        }
        tags
        metafields {
            id
            key
            value
        }
        seo {
            title
            description
        }
        variants {
            id
            storefrontId
            title
            position
            availableForSale
            inventoryQuantity
            compareAtPrice
        }
      }
    }
    
    featuredCollections: allShopifyCollection(
        filter: { handle: { in: [ "the-sanctuary-collection", "bratz", "the-sunsoaked-collection", "the-butter-yellow-collection", "the-wish-you-were-here-collection","the-palacio-del-sol-collection", "the-agua-fresca-collection", "the-henna-collection", "the-la-playa-vol-3-collection", "the-la-vie-boheme-collection", "the-city-sweetheart-collection" ] } }
    ) {
        edges {
        node {
            id
            title
            handle
            description
            image {
                gatsbyImageData
                src
            }
            updatedAt
        }
        }
    }
  }      
`;

/*
Re-add this if they request again the featured collection

homeCollection: shopifyCollection(handle: { eq: "the-sunsoaked-collection" }) {
    description
    handle
    products {
    id
    title
    handle
    featuredImage {
        src
    }
    media {
        preview {
        image {
            src
            gatsbyImageData
        }
        }
    }
    priceRangeV2 {
        minVariantPrice {
        amount
        }
    }
    tags
    metafields {
        id
        key
        value
    }
    seo {
        title
        description
    }
    variants {
        id
        storefrontId
        title
        position
        availableForSale
        inventoryQuantity
        compareAtPrice
    }
    }
}*/
export default Index